export class UserStats {
  visiblePosts = 0
  hiddenPosts = 0
  subscribedUsers = 0
  followers = 0
  reportedPostsAccepted = 0
  reportedPostsAll = 0
  postReplies = 0
  postRepliesUnseen = 0
  blockedUsers = 0
  superLikesRemaining = 0
  superLikesEntitled = 0
  superLikesGivenTotal = 0
  superLikesReceivedTotal = 0
}
